import { getDataIdsFromContract } from '../../shared/utils/dataId';

export const CREATE_PIPELINE_DATA_IDS = getDataIdsFromContract({
  base: 'create-pipeline',
  shimmer: '',
  retry: ''
});
